import React from "react";
import { FaMap } from "react-icons/fa";
import { CurrencyFormatter, DateFormatter } from "../helper/Formatter";
import { IoTime } from "react-icons/io5";

const Receipt = (props) => {
  const dataObj = props.data;
  // console.log("dataObj::: ", dataObj);

  let locale = sessionStorage.getItem("Locale");
  let currency = sessionStorage.getItem("Currency");

  //   const branchid = {
  //     "_id": "642fa6b2a01ad578cbf0da99",
  //     "branchname": "All In One",
  //     "branchlogo": "https://res.cloudinary.com/dlopjt9le/image/upload/v1586525260/mlh7afpkmoldnuo3qltc.png",
  //     "startingusernumber": "ALL IRT10000",
  //     "startingnumber": "ALL IRT10000",
  //     "supportemail": "all@gmail.com",
  //     "supportnumber": "85968574859",
  //     "currency": "INR",
  //     "workinghours": {
  //         "starttime": "10:00",
  //         "endtime": "20:00",
  //         "days": [
  //             "Monday",
  //             "Tuesday",
  //             "Wednesday",
  //             "Thursday",
  //             "Friday",
  //             "Saturday",
  //             "Sunday"
  //         ]
  //     },
  //     "timezone": "Asia/Kolkata",
  //     "locale": "en-IN",
  //     "property": {
  //         "country": "Cameroon",
  //         "address": "Addresss test all in one",
  //         "contact": "All In One",
  //         "primaryemail": "all@gmail.com",
  //         "mobile": "9685742310",
  //         "solutiontype": "Gym, Yoga Studio & Fitness Center",
  //         "pincode": null,
  //         "from": null,
  //         "replyto": null
  //     },
  //     "paymentterms": [],
  //     "taxes": [],
  //     "status": "active",
  //     "breaktime": [],
  //     "paymentmethods": [],
  //     "createdAt": "2023-04-07T05:14:26.387Z",
  //     "updatedAt": "2024-04-09T05:38:45.067Z",
  //     "addedby": "5a2cbf23ee5c2a1080793272"
  // }

  return (
    <div className="container">
      <div id="printid" style={{ margin: "0", padding: "0" }}>
        <div style={{ marginBottom: "20px" }}>
          <img src={dataObj?.branchlogo} style={{ maxWidth: "220px" }} alt="" />
        </div>
      </div>

      <h5
        style={{
          margin: "0 0 15px 0",
          fontSize: "20px",
          color: "#000000",
          fontFamily: "arial, Times New Roman, serif",
          fontWeight: "bold",
        }}
      >
        {dataObj?.branchname || ""}
      </h5>

      {dataObj.eventTitle && (
        <h4
          style={{
            margin: "0 0 15px 0",
            fontSize: "24px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            fontWeight: "bold",
          }}
        >
          {dataObj.eventTitle || ""}
        </h4>
      )}

      {dataObj?.date && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            color: "#000000",
            fontFamily: "arial,Times New Roman, serif",
            lineHeight: "1.4",
            marginRight: "15px",
          }}
        >
          <img
            src={'/public/images/date-icon.svg'}
            alt=""
            style={{
              marginRight: "8px",
              outline: "none",
              border: "0",
            }}
          />
          {DateFormatter(new Date(dataObj?.date), locale)}
        </div>
      )}

      {/* {(dataObj.endtime || dataObj.starttime) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            lineHeight: "1.4",
          }}
        >
          <img
            src={timeicon}
            alt=""
            style={{ marginRight: "0", outline: "none", border: "0" }}
          />{" "}
          {dataObj.starttime}
          {" - "}
          {dataObj.endtime}
        </div>
      )} */}

      {(dataObj.endtime || dataObj.starttime) && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            color: "#000000",
            fontFamily: "Arial, Times New Roman, serif",
            lineHeight: 1.4,
          }}
        >
         <IoTime />
          <i className="fa fa-clock-o" aria-hidden="true" />
          {dataObj.starttime} {dataObj.endtime && "-" + dataObj.endtime }
        </div>
      )}

      {dataObj?.branchaddress && (
        <div
          style={{
            marginBottom: "30px",
            display: "flex",
            alignItems: "center",
            fontSize: "15px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            lineHeight: "1.4",
          }}
        >
            <FaMap />
          {dataObj?.branchaddress}
        </div>
      )}

      {/* <div style="display: flex;margin-bottom: 10px;" >
				    <div style="display: flex;align-items: center;font-size: 15px;color: #000000;font-family: arial, Times New Roman, serif;line-height: 1.4;margin-right: 15px;" >
            <img src="images/date-black-icon.svg" alt="" style="margin-right: 8px;outline: none;border: 0;" />
            Nov 15, 2022
            </div>
					<div style="display: flex;align-items: center;font-size: 15px;color: #000000;font-family: arial, Times New Roman, serif;line-height: 1.4;">
          <img src="images/time-black-icon.svg" alt="" style="margin-right: 8px;outline: none;border: 0;"/>
          09:00 AM - 06:00 PM (Asia/Kolkata)
          </div>
				  </div> */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            marginRight: "15px",
            fontSize: "14px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            lineHeight: "1.4",
          }}
        >
          Order No. {dataObj?.billnumber}
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            lineHeight: "1.4",
          }}
        >
          Attendees: 1
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#000000",
            fontFamily: "arial, Times New Roman, serif",
            lineHeight: "1.4",
          }}
        >
          AMOUNT: {CurrencyFormatter(dataObj.charges, locale, currency)}
        </div>
      </div>

      <div style={{ border: "1px solid #000000", padding: "15px 15px 0 15px" }}>
        <div style={{ display: "flex", marginBottom: "15px" }}>
          <div style={{ width: "20%" }}>
            <img src={dataObj?.branchqr} style={{ maxWidth: "220px" }} alt="" />
          </div>
          {dataObj?.attendeename && (
            <div
              style={{ paddingLeft: "50px", paddingRight: "5px", width: "25%" }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#000000",
                  fontFamily: "arial, Times New Roman, serif",
                  lineHeight: "1.4",
                  fontWeight: "bold",
                  marginBottom: "4px",
                }}
              >
                Name
              </div>
              <div
                style={{
                  marginBottom: "15px",
                  fontSize: "14px",
                  color: "#000000",
                  fontFamily: "arial, Times New Roman, serif",
                  lineHeight: "1.4",
                  textTransform: "capitalize",
                }}
              >
                {dataObj?.attendeename}
              </div>
            </div>
          )}

          <div
            style={{ paddingLeft: "5px", paddingRight: "5px", width: "25%" }}
          ></div>
        </div>
      </div>

      <h5
        style={{
          margin: "20px 0 10px 0",
          fontSize: "18px",
          color: "#000000",
          fontFamily: "arial, Times New Roman, serif",
          fontWeight: "bold",
        }}
      >
        Organizer
      </h5>
      <div
        style={{
          border: "1px solid #000000",
          padding: "15px 15px 5px 15px",
          fontSize: "14px",
          color: "#000000",
          fontFamily: "arial, Times New Roman, serif",
          lineHeight: "1.4",
        }}
      >
        <div style={{ marginBottom: "10px" }}>{dataObj?.eventcreatedby}</div>
        <div style={{ marginBottom: "10px" }}>
          <b>Note:</b> For any further clarification, you can reach out to{" "}
          <b>{dataObj?.eventcreatedby}</b> at <b>test</b>.
        </div>
      </div>
      <h5
        style={{
          margin: "20px 0 10px 0",
          fontSize: "18px",
          color: "#000000",
          fontFamily: "arial, Times New Roman, serif",
          fontWeight: "bold",
        }}
      >
        Terms and Conditions
      </h5>
      <div
        style={{
          border: "1px solid #000000",
          padding: "15px 15px 5px 15px",
          fontSize: "14px",
          color: "#000000",
          fontFamily: "arial, Times New Roman, serif",
          lineHeight: "1.4",
        }}
      >
        <div style={{ marginBottom: "10px" }}>
          Your Order No - {dataObj?.billnumber}
        </div>
        <div style={{ marginBottom: "10px" }}>
          If the event gets cancelled, the event organizer will be responsible
          for taking decision about refund. Explara is not responsible for your
          cancellation and refund.
        </div>
        <div style={{ marginBottom: "10px" }}>
          Please carry ticket printout for entry to the event.
        </div>
        <div style={{ marginBottom: "10px" }}>
          Please carry valid identity proof to the venue.
        </div>
        <div style={{ marginBottom: "10px" }}>
          Cancellation and Rescheduling of tickets is not allowed.
        </div>
      </div>
    </div>
  );
};

export default Receipt;
